<ng-container *ngIf="isWebSite; then fullFooter; else smallFooter"></ng-container>

<ng-template #smallFooter>
  <footer class="footer footer_small d-flex justify-content-center align-items-center">
    <p [innerHTML]="'FOOTER.COPYWRITER' | translate : { year }" class="footer-text_small text-center"></p>
  </footer>
</ng-template>

<ng-template #fullFooter>
  <footer class="footer footer_big">
    <div class="footer-wrap">
      <div class="footer-block footer-block_top">
        <div class="info">
          <div class="footer-item-header">{{ 'FOOTER.SUPPORT_TITLE' | translate }}</div>
          <div class="info-wrap">
            <div *ngFor="let email of emails" class="email">
              <a [href]="[email.contact]" class="info-link">{{ email.label }}</a>
            </div>
            <div class="work-time">
              <p class="work-time-row">Пн-Нд: 9:00 - 21:00</p>
            </div>
            <div *ngFor="let phone of phones" class="phone">
              <a [href]="[phone.contact]" class="info-link">{{ phone.label }}</a>
              <p class="info-label">{{ phone.type | translate }}</p>
            </div>
          </div>
        </div>
        <div class="navigation">
          <div class="footer-item-header">{{ 'FOOTER.LINKS_TITLE' | translate }}</div>
          <div class="navigation-wrap">
            <div *ngFor="let item of routes" class="navigation-item" routerLinkActive="active">
              <a [routerLink]="[item.route]" class="navigation-link">{{ item.label | translate }}</a>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-block footer-block_middle">
        <div class="annex">
          <div class="footer-item-header">{{ 'FOOTER.ANNEX.TITLE' | translate }}</div>
          <div class="annex-wrap">
            <a *ngFor="let item of annex" [href]="item.link" class="annex-item">
              <div class="annex-icon"><img [src]="item.icon" alt="icon" /></div>
              <p class="annex-label">{{ item.label | translate }}</p>
            </a>
          </div>
        </div>
        <div class="feedback">
          <div class="feedback-buttons d-flex flex-column justify-content-center flex-md-row align-items-md-center">
            <div class="footer-button">
              <a [routerLink]="'auth/login'" class="footer-btn">{{ 'FOOTER.BTN' | translate }}</a>
            </div>
            <div class="complaint">
              <a [routerLink]="'freepayment'" class="complaint-link">{{ 'FOOTER.BTN_PAY' | translate }}</a>
            </div>
          </div>
          <p class="address">{{ 'FOOTER.ADDRESS' | translate }}</p>
          <div class="feedback-options">
            <h3 class="feedback-options-title">{{ 'FOOTER.FEEDBACK.TITLE' | translate }}</h3>
            <p class="feedback-options-info">{{ 'FOOTER.FEEDBACK.INFO1' | translate }}</p>
            <p [innerHTML]="'FOOTER.FEEDBACK.INFO2' | translate" class="feedback-options-info"></p>
            <p [innerHTML]="'FOOTER.FEEDBACK.INFO3' | translate" class="feedback-options-info"></p>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-bottom">
      <div class="social">
        <!-- <a *ngFor="let item of social" [href]="item.href" class="social-item">
           <img [alt]="item.alt" [src]="item.img" class="mr-2">
         </a>-->
      </div>
      <div class="copywrite">{{ 'FOOTER.COPYWRITER' | translate: {year: year} }}</div>
    </div>
  </footer>
</ng-template>
